export default {
    BRAND_PAGE: 'Brand',
    BRAND_LIST_PAGE: 'BrandList',
    CATEGORY_LIST: 'CategoryList',
    CATEGORY_RESULT_PAGE: 'Category',
    CUSTOM_RESULT_PAGE: 'CustomResults',
    DEFAULT: 'default',
    ENDLESS_RECOMMENDATIONS_PAGE: 'EndlessRecommendation',
    ERROR_PAGE: 'ErrorPage',
    FAVOURITE_SELLERS_PAGE: 'FavouriteSellers',
    MY_TRADERA_PAGE: 'MyTradera',
    PROFILE_PAGE: 'ProfilePage',
    REPORT_ITEM_PAGE: 'ReportItem',
    SEARCH_RESULT_PAGE: 'SearchResults',
    START_PAGE: 'StartPage',
    SYI_PAGE: 'SellItem',
    TRADERA_SHOP_PAGE: 'TraderaShop',
    VALUATION: 'Valuation',
    VIEW_ITEM_PAGE: 'VIP'
};
